
const Pay = {
    data() {
        return {
            VUE_APP_NEXT_BASIC_URL: process.env.VUE_APP_NEXT_BASIC_URL
        }
    },
    methods: {
        goBack() {
            if (this.$route.query.display && this.$route.query.display === '1') {
                history.go(-1)
            } else {
                location.href = `${this.VUE_APP_NEXT_BASIC_URL}/details/${
                    this.$route.params.id
                    }`;
            }

        }
    },
    mounted() {
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener("popstate", this.goBack, false);
        }
    },
    destroyed() {
        window.removeEventListener("popstate", this.goBack, false);
    }
};

export default Pay